export const LIST_ORGANIZATIONS_URL = "/api/organizations";
export const PAYMENT_TYPES_URL = "/api/payment-types";
export const ORGANISATIONS_ADMIN_URL = "/v2/api/users";
